import React, { FC } from 'react'

import { Photos } from 'components/page/ForeignProfile/common.types'

import { ProfilePhotoMore } from './ProfilePhotoMore'

export const ProfileMoreSwitch: FC<{
  photos?: Photos
}> = ({ photos }) => {
  if (photos && photos.length > 0) {
    return (
      <ProfilePhotoMore
        photoId={photos[0].photoId}
        source={photos[0].urls.squareSmall}
        count={photos.length}
      />
    )
  }

  return null
}
